import SEO from "../components/site/SEO";
import {
  CTASection,
  HighlightList,
  InfoCard,
  PageHero,
  SectionHeader,
} from "../components/site/Sections";
import { companyInfo } from "../content/siteContent";

const ServiceDetailPage = ({ service }) => {
  if (!service) {
    return null;
  }

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.title,
    description: service.metaDescription,
    areaServed: `${companyInfo.city} e região metropolitana`,
    serviceType: service.keyword,
    provider: {
      "@type": "LocalBusiness",
      name: companyInfo.name,
      telephone: companyInfo.phoneDisplay,
      email: companyInfo.email,
    },
  };

  return (
    <>
      <SEO
        title={service.seoTitle}
        description={service.metaDescription}
        canonicalPath={service.path}
        keywords={[service.keyword, "engenharia elétrica em São Paulo", "subestações", "cabine primária"]}
        structuredData={[serviceSchema]}
      />

      <PageHero
        eyebrow="Especialidade técnica"
        title={service.title}
        description={service.intro}
        image={service.image}
        ctaMessage={`Olá, gostaria de solicitar orçamento para ${service.title.toLowerCase()}.`}
        testId={`service-hero-${service.menuName.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      />

      <section className="container-shell py-14 md:py-20" data-testid="service-overview-section">
        <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:items-start">
          <InfoCard
            title="Escopo do serviço"
            description={`A atuação da W-Electric em ${service.keyword} é direcionada para ambientes em que segurança, continuidade operacional e conformidade técnica são prioridades.`}
            items={service.activities}
            testId="service-overview-card"
            dark
          />

          <div className="space-y-8">
            <SectionHeader
              eyebrow="Importância da manutenção"
              title="Prevenção, rastreabilidade e decisão técnica"
              description={service.intro}
              testId="service-overview-header"
            />

            <div className="surface-card p-6 md:p-8" data-testid="service-keyword-box">
              <p className="text-sm font-semibold uppercase tracking-[0.26em] text-safety" data-testid="service-keyword-label">
                Palavra-chave SEO
              </p>
              <p className="mt-3 font-heading text-3xl uppercase text-brand" data-testid="service-keyword-text">
                {service.keyword}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="container-shell py-4 md:py-8" data-testid="service-process-section">
        <SectionHeader
          eyebrow="Metodologia"
          title="Como conduzimos a entrega técnica"
          description="Cada etapa é executada com critérios claros, documentação consistente e foco em liberar o sistema com o menor risco possível."
          testId="service-process-header"
        />

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {service.process.map((step, index) => (
            <InfoCard
              key={step.title}
              title={`${String(index + 1).padStart(2, "0")} ${step.title}`}
              description={step.description}
              testId={`service-process-card-${index + 1}`}
            />
          ))}
        </div>
      </section>

      <section className="bg-brand py-14 md:py-20" data-testid="service-benefits-section">
        <div className="container-shell grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <SectionHeader
            eyebrow="Benefícios"
            title="Por que esse serviço é estratégico para sua operação"
            description="A combinação entre análise técnica, execução segura e documentação confiável reduz exposição a falhas e aumenta previsibilidade operacional."
            testId="service-benefits-header"
            light
          />
          <HighlightList items={service.benefits} testId="service-benefits-list" light />
        </div>
      </section>

      <CTASection
        title="Solicite uma avaliação técnica"
        description={`Converse com a W-Electric sobre ${service.title.toLowerCase()} e receba orientação objetiva para manter sua instalação elétrica segura e confiável.`}
        buttonLabel="Solicitar orçamento"
        buttonMessage={`Olá, quero solicitar orçamento para ${service.title.toLowerCase()}.`}
        testId="service-detail-cta"
      />
    </>
  );
};

export default ServiceDetailPage;